export default __webpack_public_path__ + "static/media/tl5.9b939873.webp";